export default __webpack_public_path__ + "9a696b9c5ab57c1e59f6a5b684297aa2.png";